// eslint-disable-next-line import/no-cycle
import responseHandler from "../system/server-response-handler";
import {
  putRequest,
  getRequest,
  postRequest,
  deleteRequest,
  postRequestWithProgress,
  deleteRequestWithPayload,
} from "../system/server-call";
import { COMMON_URL } from "../system/global-enums";

// Fetches a paginated list of completed events with optional filtering.
const getCompletedEvents = (
  pageSize,
  pageNumber,
  filterExpression,
  orderBy
) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.ADMIN}/event/GetCompletedEvents?PageSize=${pageSize}&PageNumber=${pageNumber}&FilterExpression=${filterExpression}&OrderBy=${orderBy}&language=en&`,
      true
    )
  );
};

// Fetches a paginated list of upcoming events with optional filtering.
const getUpcomingEvents = (
  pageSize,
  pageNumber,
  filterExpression,
  orderBy = "Id desc"
) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.ADMIN}/event/GetUpcomingEvents?PageSize=${pageSize}&PageNumber=${pageNumber}&FilterExpression=${filterExpression}&OrderBy=${orderBy}&language=en&`,
      true
    )
  );
};

// Fetches a paginated list of canceled events with optional filtering.
const getCanceledEvents = (pageSize, pageNumber, filterExpression, orderBy) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.ADMIN}/event/GetCanceledEvents?PageSize=${pageSize}&PageNumber=${pageNumber}&FilterExpression=${filterExpression}&OrderBy=${orderBy}&language=en&`,
      true
    )
  );
};

// Cancels an event by its ID.
const cancelEvent = (eventGroupId, id) => {
  const url = id
    ? `${COMMON_URL.ADMIN}/Event/${eventGroupId}/${id}`
    : `${COMMON_URL.ADMIN}/Event/${eventGroupId}`;

  return responseHandler.processServerCallResponse(deleteRequest(url, true));
};

// Retrieves a list of ShutterBs assigned to a specific event.
const viewEventShutterbs = (id) => {
  return responseHandler.processServerCallResponse(
    getRequest(`${COMMON_URL.ADMIN}/ShutterB/GetSBForEvent/${id}`, true)
  );
};

// Reassigns ShutterBs to an event.
const resAssignShutterbs = (eventId, data) => {
  return putRequest(
    `${COMMON_URL.ADMIN}/ShutterB/ReassignSBForEvent/${eventId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerMessageResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Retrieves the shared gallery images for a specific event.
const getEventGallery = (eventId, isActive) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.USER}/EventGallery/SharedGalleryFiles/${eventId}/${isActive}`,
      true
    )
  );
};

// Downloads selected event files (bulk download).
const downloadSelectedFiles = (eventIdsArr) => {
  return postRequest(
    `/api/v1/ShutterB/Event/DownloadEventFiles`,
    eventIdsArr,
    true
  ).then(
    (response) => responseHandler.handleServerMessageResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Deletes selected files from the event gallery.
const deleteFromGallery = (dataObj) => {
  return responseHandler.processServerCallResponse(
    deleteRequestWithPayload(`${COMMON_URL.USER}/EventGallery`, dataObj, true)
  );
};

// Uploads files to the event gallery with progress tracking.
const addToGallery = (data, options) => {
  return responseHandler.processServerCallResponse(
    postRequestWithProgress(
      `${COMMON_URL.ADMIN}/Event/AddEventFiles`,
      data,
      true,
      options
    )
  );
};

// Fetches event detail using the event ID.
const getEventDetailByEventId = (eventId) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.ADMIN}/event/GetEventDetailByEventId/${eventId}`,
      true
    )
  );
};

// Marks a clip as favorite in the gallery.
const favoriteClip = (clipId) => {
  return responseHandler.processServerCallResponse(
    putRequest(
      `${COMMON_URL.USER}/EventGallery/FavoriteClip/${clipId}`,
      {},
      true
    )
  );
};

// Retrieves the shared gallery images for a group event.
const getGroupEventGallery = (groupEventId, isActive) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.USER}/EventGallery/SharedGalleryFiles/GroupEvents/${groupEventId}/${isActive}`,
      true
    )
  );
};

// Exporting all event-related service functions
export const eventsServices = {
  cancelEvent,
  addToGallery,
  favoriteClip,
  getEventGallery,
  getUpcomingEvents,
  getCanceledEvents,
  deleteFromGallery,
  getCompletedEvents,
  viewEventShutterbs,
  resAssignShutterbs,
  getGroupEventGallery,
  downloadSelectedFiles,
  getEventDetailByEventId,
};
